module.exports = [{
      plugin: require('/codebuild/output/src137576783/src/gatsby-auth-starter-aws-amplify/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
